export const MAIN_SLUG_FIELD_KEY = '_slug'

export const MAIN_SLUG_FIELD_DISPLAY_NAME = 'Slug item'

export const PAGE_LINK_FIELD_PREFIX = '_pageLink_'
